import { RouteType } from "types/RouteType";
import DockerHostsStore from "./DockerHostsStore";

const dockerHostsRoute: RouteType[] = [
  {
    name: "Docker Hosts",
    path: "/infrastructure/docker-hosts",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Docker Hosts",
        enableRefreshButton: true,
        component: () => import("./DockerHosts.Header"),
      },
      body: {
        component: () => import("./DockerHosts.Body"),
        grayBackground: true,
      },
    },
    group: "Infrastructure",
    searchAliases: ["servers", "hosts"],
    // Read-only control-plane view. Reads require authentication only (viewer+);
    // the API enforces the read gate (rbac.ts viewer/operator/admin seam). Host
    // registration + the write-only Portainer API key (encrypted at rest, never
    // returned) land with the Phase 5 action seam — no writes here yet.
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.dockerHostsViewStore as DockerHostsStore;
      store?.loadHosts();
    },
  },
];

export default dockerHostsRoute;
